
import React from 'react';

export const DynamicBackground: React.FC = () => {
    return (
        <>
            <div className="absolute inset-0 -z-30">
                <div className="absolute inset-0 dot-grid"></div>
                <div className="absolute inset-0 overflow-hidden">
                    <div className="roaming-light animate-light-roam"></div>
                </div>
            </div>
            <div className="grain-overlay -z-10"></div>
        </>
    );
};
